<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (phoneNumber of phoneNumbers | async; track trackBy(phoneNumber)) { @if ( !onlyAllowOutboundCallsNumbers ||
      (onlyAllowOutboundCallsNumbers && phoneNumber.allowOutboundCalls === true) || (includeFax &&
      phoneNumber.faxExtensionId != null) ) {
      <lcs-option [value]="phoneNumber" id="lcs-option-id-{{ phoneNumber.phoneNumberId }}">
         {{ phoneNumber.phoneNumber | formatPhoneNumbers }}@if (phoneNumber.displayName) {
         <span> - {{ phoneNumber.displayName }}</span>
         }
      </lcs-option>
      } }
   </div>
</ng-template>
